module.exports = __webpack_public_path__ + "static/media/wowza-logo.9303433f.svg";